import {
	getSearchConfig,
	type TSearchConfigAPIResponse,
} from '@atlassian/search-client/fetch-search-config';

import { createResource } from '@townsquare/router/resources/createResource';
import type { RouteResource } from '@townsquare/router/resources/types';

export const searchConfigurationResource: RouteResource<TSearchConfigAPIResponse> =
	createResource<TSearchConfigAPIResponse>({
		getData: async (_, __) => {
			return await getSearchConfig({})
				.then((data) => {
					return data;
				})
				.catch(() => {
					return {
						resources: [],
						intercomHmac: '',
						siteMetadata: [],
					};
				});
		},
		getKey: () => 'search-configuration-resource-key',
		type: 'SEARCH_CONFIGURATION',
	});
